<template>
  <div id="detail-akun-page">
    <page-header-component icon="bi bi-info-circle" title="Detail Akun" v-if="topics" @filterChange="filterChange"
      :topics="topics" />
    <div class="row">
      <div class="col-md-4 px-gap">
        <div class="card h-100 shade">
          <div class="card-body mt-3">
            <center>
              <img v-if="account.profile_image" :src="account.profile_image" width="100" alt="" @error="imageError()"
                class="img-circle" />
              <img v-else src="../../../public/assets/img/profiles/default.png" alt="" class="img-circle" />
            </center>
            <div class="d-flex mt-2">
              <h3 class="ml-auto mr-2" v-if="account.source != 'media_cetak' &&
                account.source != 'media_tv'
                ">
                {{ account ? account.name : "" }}
              </h3>
              <h3 class="mx-auto mr-2" v-else>
                {{ account ? account.name : "" }}
              </h3>
              <a v-if="account.source != 'media_cetak' &&
                account.source != 'media_tv'
                " :href="account.id_account.includes('http')
    ? account.id_account
    : '//' + account.id_account
    " target="_blank" class="mr-auto mt-2 text-complete hoverable clickable">
                <i class="bi bi-box-arrow-up-right"></i>
              </a>
            </div>
            <div class="d-flex align-items-center" v-if="account.location != null && account.location != ''">
              <i class="bi bi-geo-alt ml-auto mr-1" style="font-size: large"></i><span class="mr-auto"> {{
                account.location }}</span>
            </div>
            <loader-component v-if="is_detail_loading" />
            <div v-else class="row mt-5">
              <div class="text-center col-md-3" v-if="account.source != 'media_cetak' &&
                account.source != 'media_tv' &&
                account.source != 'news'
                ">
                <i class="bi bi-chat-left-text fa-1x"></i> <br />
                <small>Mentions</small>
                <br />
                <span class="h6 font-weight-bold">
                  {{ account.total ? numberFormater(account.total, 1) : 0 }}
                </span>
              </div>
              <div v-else class="text-center" :class="account.tier == null ? 'col-md-4' : 'col-md-3'">
                <i class="bi bi-chat-left-text" style="font-size: 16px"></i>
                <br />
                <small>Mentions</small>
                <br />
                <span class="h6 font-weight-bold">
                  {{ account.total ? numberFormater(account.total, 1) : 0 }}
                </span>
              </div>
              <div class="col-md-3 text-center" v-if="account.source != 'media_cetak' &&
                account.source != 'media_tv' &&
                account.source != 'news'
                ">
                <i class="bi bi-share-fill fa-1x"></i> <br />
                <small>Keterlibatan</small> <br />
                <span class="h6 font-weight-bold">
                  {{
                    account.engagement
                    ? numberFormater(account.engagement, 1)
                    : 0
                  }}
                </span>
              </div>
              <div class="col-md-3 text-center" v-if="account.source != 'media_cetak' &&
                  account.source != 'media_tv' &&
                  account.source != 'news'
                  ">
                <i class="bi bi-megaphone fa-1x"></i> <br />
                <small>Jangkauan</small> <br />
                <span class="h6 font-weight-bold">
                  {{ account.esmr ? numberFormater(account.esmr, 1) : 0 }}
                </span>
              </div>
              <div class="col-md-3 text-center" v-if="account.source != 'media_cetak' &&
                account.source != 'media_tv' &&
                account.source != 'news'
                ">
                <i class="bi bi-person fa-1x"></i> <br />
                <small>Pengikut</small> <br />
                <span class="h6 font-weight-bold">
                  {{
                    account.followers ? numberFormater(account.followers, 1) : 0
                  }}
                </span>
              </div>
              <div class="text-center" :class="account.tier ? 'col-md-3' : 'col-md-4'" v-if="account.source == 'media_cetak' ||
                account.source == 'media_tv' ||
                account.source == 'news'
                ">
                <span class="h5 font-weight-bold">PR</span> <br />
                <small>PR Value</small> <br /><span class="h6 font-weight-bold">
                  IDR
                  {{
                    account.pr_value ? numberFormater(account.pr_value, 1) : 0
                  }}
                </span>
              </div>
              <div class="text-center" :class="account.tier ? 'col-md-3' : 'col-md-4'" v-if="account.source == 'media_cetak' ||
                account.source == 'media_tv' ||
                account.source == 'news'
                ">
                <span class="h5 font-weight-bold">AD</span> <br />
                <small>AD Value</small> <br /><span class="h6 font-weight-bold">
                  IDR
                  {{
                    account.ad_value ? numberFormater(account.ad_value, 1) : 0
                  }}
                </span>
              </div>
              <div class="text-center" :class="account.tier ? 'col-md-3' : ''" v-if="(account.source == 'media_cetak' ||
                  account.source == 'media_tv' ||
                  account.source == 'news') &&
                account.tier
                ">
                <span class="h5 font-weight-bold">TINGKAT</span> <br />
                <small>Tingkat Media</small> <br />
                <span class="h6 font-weight-bold">{{ account.tier }}</span>
              </div>
            </div>
            <center style="margin-top: 5rem">
              <h4 class="mb-5">Sentimen Postingan</h4>
              <loader-component v-if="is_detail_loading" />
              <div v-else>
                <pie-chart-component v-if="sentimen_post" :data="sentimen_post" />
                <div v-else class="alert alert-danger text-center">
                  <span class="h6">Mohon maaf, data tidak tersedia!</span>
                  <br />
                  <span>
                    Silahkan melakukan pencarian dengan menggunakan parameter
                    lain
                  </span>
                </div>
              </div>
              <div v-if="sentimen_post" class="row mt-5">
                <div class="col-md-4">
                  Sentimen Positif <br />
                  <div class="d-flex align-items-center mt-2 text-success">
                    <i class="ml-auto bi bi-emoji-smile fa-2x"></i>
                    <strong class="mr-auto ml-1 h5 mt-2">
                      {{ account.positif }} %
                    </strong>
                  </div>
                </div>
                <div class="col-md-4">
                  Sentimen Netral <br />
                  <div class="d-flex align-items-center mt-2 text-secondary">
                    <i class="ml-auto bi bi-emoji-neutral fa-2x"></i>
                    <strong class="mr-auto ml-1 h5 mt-2">
                      {{ account.netral }} %
                    </strong>
                  </div>
                </div>
                <div class="col-md-4">
                  Sentimen Negatif <br />
                  <div class="d-flex align-items-center mt-2 text-danger">
                    <i class="ml-auto bi bi-emoji-frown fa-2x"></i>
                    <strong class="mr-auto ml-1 h5 mt-2">
                      {{ account.negatif }} %
                    </strong>
                  </div>
                </div>
              </div>
            </center>
          </div>
        </div>
      </div>
      <div class="col-md-8 px-gap">
        <div class="row">
          <div class="col-md-12">
            <div class="card h-100 shade">
              <div class="card-header">
                <h4>Tren Postingan</h4>
              </div>
              <div class="card-body">
                <loader-component v-if="is_detail_loading" />
                <div v-else>
                  <line-chart-component v-if="trend_post.x" :series="trend_post" />
                  <div v-else class="alert alert-danger text-center">
                    <span class="h6"> Mohon maaf, data tidak tersedia! </span>
                    <br />
                    <span>
                      Silahkan melakukan pencarian dengan menggunakan parameter
                      lain
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12">
            <div class="card h-100 shade">
              <div class="card-header">
                <h4>Postingan Terbaru</h4>
              </div>
              <div class="card-body">
                <loader-component v-if="is_post_loading" />
                <div v-else>
                  <div v-if="!posts" class="alert alert-danger text-center">
                    <span class="h6"> Mohon maaf, data tidak tersedia! </span>
                    <br />
                    <span>
                      Silahkan melakukan pencarian dengan menggunakan parameter
                      lain
                    </span>
                  </div>
                  <div class="scroller" style="max-height: 30rem" v-else>
                    <post-list-simple-component :posts="posts" :is_title_clicked="false" />
                    <div class="row mt-4" style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        margin-left: 0px !important;
                        margin-right: 0px !important;
                      ">
                      <div class="col-md-6">
                        {{ paginationInfo() }}
                      </div>
                      <div class="col-md-6 p-l-1 p-r-0">
                        <pagination-component v-if="page_info" :data="page_info" :goto="true" class="pull-right" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import page_header from "@/views/components/page_header.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import post_list_simple from "@/views/components/post_list_simple.vue";
import loader_component from "@/views/components/loader.vue";
import pagination_component from "@/views/components/pagination.vue";
import gp from "@/plugins/generalPlugins.js";

export default {
  name: "DetailAkun",
  title: "Detail Akun | Sibernetik",
  components: {
    "page-header-component": page_header,
    "pie-chart-component": pie_chart,
    "line-chart-component": line_chart,
    "post-list-simple-component": post_list_simple,
    "loader-component": loader_component,
    "pagination-component": pagination_component,
  },
  data() {
    return {
      id_project: this.$store.getters.user.id_project,
      sentimen_post: null,
      trend_post: {
        x: null,
        y: [
          {
            color: "#28a745",
            data: null,
            name: "Positif",
          },
          {
            color: "#0e6d87AA",
            data: null,
            name: "Netral",
          },
          {
            color: "#dc3545AA",
            data: null,
            name: "Negatif",
          },
        ],
      },
      topics: null,
      posts: null,
      id_account: atob(this.$route.query.key),
      account: {
        name: this.$route.query.account,
        ad_value: 0,
        engagement: 0,
        esmr: 0,
        followers: 0,
        id_account: "",
        location: null,
        negatif: 0,
        netral: 0,
        positif: 0,
        pr_value: 0,
        profile_image: "",
        source: "media_cetak",
        tier: null,
        total: 0,
        _id: "",
      },
      current_page: 1,
      page_info: null,
      is_detail_loading: true,
      is_post_loading: true,
    };
  },
  methods: {
    getDetail: function () {
      let self = this;
      self.is_detail_loading = true;
      self.account.ad_value = 0;
      self.account.engagement = 0;
      self.account.esmr = 0;
      self.account.followers = 0;
      self.account.negatif = 0;
      self.account.positif = 0;
      self.account.netral = 0;
      self.account.pr_value = 0;
      self.account.tier = 0;
      self.account.total = 0;
      self.sentimen_post = null;
      self.trend_post.x = null;
      let params = {
        id_account: self.id_account,
        from: self.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        to: self.$store.getters.filter_date_to.format("YYYY-MM-DD HH:mm:ss"),
      };
      if ("topic_selected" in self.$route.query) {
        params.topic_selected = self.$route.query.topic_selected;
      }
      if ("cakupan" in self.$route.query) {
        params.cakupan = self.$route.query.cakupan;
      }
      if ("group" in self.$route.query) {
        params.group = self.$route.query.group;
      }

      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL +
        "account/detail/" +
        self.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then(function (response) {
          self.account.ad_value = response.data.account.ad_value;
          self.account.engagement = response.data.account.engagement;
          self.account.esmr = response.data.account.esmr;
          self.account.followers = response.data.account.followers;
          self.account.id_account = response.data.account.id_account;
          self.account.location = response.data.account.location;
          self.account.negatif = (
            (response.data.account.negatif / response.data.account.total) *
            100
          ).toFixed();
          self.account.netral = (
            (response.data.account.netral / response.data.account.total) *
            100
          ).toFixed();
          self.account.positif = (
            (response.data.account.positif / response.data.account.total) *
            100
          ).toFixed();
          self.account.pr_value = response.data.account.pr_value;
          self.account.profile_image = response.data.account.profile_image;
          self.account.source = response.data.account.source;
          self.account.tier = response.data.account.tier;
          self.account.total = response.data.account.total;
          self.account._id = response.data.account._id;
          (self.sentimen_post = [
            {
              color: "#28a745",
              name: "Positif",
              y: response.data.account.positif,
            },
            {
              color: "#0e6d87AA",
              name: "Netral",
              y: response.data.account.netral,
            },
            {
              color: "#dc3545AA",
              name: "Negatif",
              y: response.data.account.negatif,
            },
          ]),
            (self.trend_post.x = response.data.trend.categories);
          self.trend_post.y[0].data = response.data.trend.series.positif;
          self.trend_post.y[1].data = response.data.trend.series.netral;
          self.trend_post.y[2].data = response.data.trend.series.negatif;
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.is_detail_loading = false;
        });
    },
    getPosts: function () {
      let self = this;
      self.is_post_loading = true;
      let params = {
        id_account: self.id_account,
        from: self.$store.getters.filter_date_from.format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        to: self.$store.getters.filter_date_to.format("YYYY-MM-DD HH:mm:ss"),
        page: self.current_page,
      };
      if ("topic" in self.$route.query) {
        params.topic = self.$route.query.topic;
      }
      if ("group" in self.$route.query) {
        params.group = self.$route.query.group;
      }
      if ("is_validated" in self.$route.query) {
        params.is_validated = self.$route.query.is_validated;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api =
        process.env.VUE_APP_API_URL +
        "posts-dev/" +
        self.id_project +
        "?" +
        query;
      this.$http
        .get(api, params)
        .then(function (response) {
          if (response.data != "" || response.data != null) {
            self.posts = response.data.posts;
            self.page_info = response.data.page_info;
          } else {
            self.posts = null;
          }
        })
        .catch(function (err) {
          console.log(err);
        })
        .finally(function () {
          self.is_post_loading = false;
        });
    },
    getTopic: function () {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.topics = {};
          } else {
            self.topics = response.data;
          }
        })
        .catch(function () {
          self.topics = {};
        })
        .finally(() => {
          this.getDetail();
          this.getPosts();
        });
    },
    thousandSeparator(value) {
      return gp.thousandSeparator(value);
    },
    paginationInfo: function () {
      let text = "";
      if (this.page_info != null) {
        let data_start =
          this.page_info.limit * this.page_info.page -
          (this.page_info.limit - 1);
        let data_end = this.page_info.limit * this.page_info.page;
        if (data_end > this.page_info.total) {
          data_end = this.page_info.total;
        }
        text =
          "Menampilkan " +
          data_start +
          " - " +
          data_end +
          " dari " +
          this.thousandSeparator(this.page_info.total);
      }

      return text;
    },
    imageError() {
      event.target.src = "/assets/img/profiles/default.png";
    },
    filterChange: function () {
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query) {
        this.getTopic();
      }
    },
    numberFormater: function (num, digits) {
      var si = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "rb" },
        { value: 1e6, symbol: "jt" },
        { value: 1e9, symbol: "M" },
        { value: 1e12, symbol: "T" },
      ];
      var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
      var i;
      for (i = si.length - 1; i > 0; i--) {
        if (Math.abs(num) >= si[i].value) {
          break;
        }
      }
      let val = (
        (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol
      ).replaceAll(".", ",");
      return val;
    },
  },
  created() {
    this.getTopic();
  },
  watch: {
    $route() {
      if (this.$route.query.page) {
        this.current_page = this.$route.query.page;
      }
      this.getPosts();
    },
  },
};
</script>
<style scoped>
.img-circle {
  height: 100% !important;
  width: 100% !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 80px;
  max-width: 80px;
}
</style>
